<!-- eslint-disable @angular-eslint/template/no-inline-styles -- This is internal stuff! -->
<mat-card class="mb-5">
  <mat-card-content class="p-6" (click)="onClickContainer()">
    <div class="flex flex-col gap-y-6 items-center">
      <mat-radio-group [value]="selectedPage" class="flex flex-row gap-x-6" (change)="selectedPage = $event.value">
        @for (page of pages; track page.value) {
          <mat-radio-button [value]="page.value">
            {{ page.label }}
          </mat-radio-button>
        }
      </mat-radio-group>

      <p class="text-body-medium">
        <span>{{ selectedPageDescription }}</span>
        <span class="italic">&nbsp;(Source: {{ selectedPageSource }})</span>
      </p>

      <div class="flex flex-col justify-center min-h-[8.6rem] rounded-md border border-outline-variant p-4" (click)="$event.stopPropagation()">
        @if (selectedSwatch) {
          <div class="flex flex-col gap-y-2">
            <div class="flex flex-row items-center gap-x-1">
              <p class="text-title-medium w-24">TOKEN:</p>
              <p class="text-body-large">{{ selectedTokenName }}</p>
            </div>

            <div class="flex flex-row items-center gap-x-1">
              <p class="text-title-medium w-24">TAILWIND:</p>
              <p class="text-body-large">{{ selectedTailwindName }}</p>
            </div>

            <div class="flex flex-row items-center gap-x-1">
              <p class="text-title-medium w-24">FIGMA:</p>
              <p class="text-body-large">{{ selectedFigmaName }}</p>
            </div>

            <div class="flex flex-row items-center gap-x-1">
              <p class="text-title-medium w-24">RGB:</p>
              <p class="text-body-large">{{ selectedRgbValue }}</p>
            </div>
          </div>
        } @else {
          <span class="text-on-surface-variant">
            Click a color to see its details.
          </span>
        }
      </div>

      @switch (selectedPage) {
        @case ('main-theme') {
          <div class="flex justify-center gap-x-8">
            <!-- Theme -->
            <div class="flex flex-col gap-y-4">
              <p class="text-title-small">Theme</p>

              @for (row of mainThemeRows; track $index) {
                <div class="relative grid grid-cols-4">
                  @for (name of row; track name) {
                    @if (mainThemeSwatchFor(name); as swatch) {
                      <ng-container *ngTemplateOutlet="colorSwatch; context: {$implicit: swatch}"/>
                    }
                  }
                </div>
              }
            </div>

            <!-- Surfaces -->
            <div class="flex flex-col gap-y-4">
              <p class="text-title-small">Surfaces</p>

              <div class="relative flex flex-col gap-y-4">
                @for (name of mainThemeSurfaceNames; track name) {
                  @if (mainThemeSwatchFor(name); as swatch) {
                    <ng-container *ngTemplateOutlet="colorSwatch; context: {$implicit: swatch}"/>
                  }
                }
              </div>
            </div>
          </div>
        }
        @case ('semantic-aliases') {
          <div class="flex flex-col gap-y-6">
            @for (group of semanticAliasGroups; track group.label) {
              <div class="flex flex-col gap-y-2">
                <p class="text-title-small">{{ group.label }}</p>

                <div class="grid grid-cols-3 gap-4">
                  @for (pair of group.pairs; track pair.colorName) {
                    <div class="grid grid-cols-2 gap-0">
                      @if (pair.color; as swatch) {
                        <ng-container *ngTemplateOutlet="colorSwatch; context: {$implicit: swatch}"/>
                      } @else {
                        <ng-container *ngTemplateOutlet="missingColorPlaceholder; context: {$implicit: 'background'}"/>
                      }

                      @if (pair.onColor; as swatch) {
                        <ng-container *ngTemplateOutlet="colorSwatch; context: {$implicit: swatch}"/>
                      } @else {
                        <ng-container *ngTemplateOutlet="missingColorPlaceholder; context: {$implicit: 'on-'}"/>
                      }
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
        @case ('other-figma') {
          <div class="grid grid-cols-3 gap-4">
            @for (pair of otherFigmaPairs; track pair.colorName) {
              <div class="grid grid-cols-2">
                @if (pair.color; as swatch) {
                  <ng-container *ngTemplateOutlet="colorSwatch; context: {$implicit: swatch}"/>
                } @else {
                  <ng-container *ngTemplateOutlet="missingColorPlaceholder; context: {$implicit: 'background'}"/>
                }

                @if (pair.onColor; as swatch) {
                  <ng-container *ngTemplateOutlet="colorSwatch; context: {$implicit: swatch}"/>
                } @else {
                  <ng-container *ngTemplateOutlet="missingColorPlaceholder; context: {$implicit: 'on-'}"/>
                }
              </div>
            }
          </div>
        }
        @case ('reference') {
          <div class="flex flex-col gap-y-2">
            @for (palette of referencePalettes; track palette.label) {
              <div class="grid grid-cols-[10rem_1fr] items-center">
                <span class="text-label-medium text-align-end">{{ palette.label }}</span>

                <div class="flex">
                  @for (swatch of palette.swatches; track swatch.tokenName) {
                    <div class="relative flex-1 min-w-12 h-16 cursor-pointer"
                         [style.background-color]="cssColorFor(swatch.tokenName)"
                         [class.ring-4]="isSelected(swatch)"
                         [class.ring-mat-red-500]="isSelected(swatch)"
                         [class.ring-offset-2]="isSelected(swatch)"
                         [class.z-10]="isSelected(swatch)"
                         (click)="onClickSwatch($event, swatch)">
                      <span class="absolute left-1 top-1 min-w-5 h-3 px-1 inline-flex items-center justify-center rounded-sm border border-surface/70
                       bg-on-surface/50 text-surface text-[11px] leading-none">
                        {{ swatch.label }}
                      </span>
                    </div>

                  }
                </div>
              </div>
            }
          </div>
        }
        @case ('material') {
          <div class="grid grid-cols-[8rem_repeat(14,3rem)] gap-px w-fit">
            <span></span>

            @for (shade of materialPalettes[0].swatches; track shade.label) {
              <span class="text-label-medium text-center">
                {{ shade.label }}
              </span>
            }

            @for (palette of materialPalettes; track palette.label) {
              <span class="text-label-medium justify-self-end self-center pe-3">
                {{ palette.label }}
              </span>

              @for (swatch of palette.swatches; track swatch.tokenName) {
                @if (swatch.available !== false) {
                  <div
                    class="size-12"
                    [style.background-color]="cssColorFor(swatch.tokenName)"
                    [class.ring-4]="isSelected(swatch)"
                    [class.ring-mat-red-500]="isSelected(swatch)"
                    [class.ring-offset-2]="isSelected(swatch)"
                    [class.z-10]="isSelected(swatch)"
                    (click)="onClickSwatch($event, swatch)"
                  ></div>
                } @else {
                  <div class="size-12 bg-surface1 flex items-center justify-center">
                    <span class="text-label-small text-on-surface-variant">N/A</span>
                  </div>
                }
              }
            }
          </div>
        }
      }
    </div>
  </mat-card-content>
</mat-card>

<ng-template #colorSwatch let-swatch>
  <button
    type="button"
    class="relative w-40 h-20 text-left p-2"
    [style.background-color]="cssColorFor(swatch.tokenName)"
    [class.ring-4]="isSelected(swatch)"
    [class.ring-mat-red-500]="isSelected(swatch)"
    [class.z-10]="isSelected(swatch)"
    (click)="onClickSwatch($event, swatch)"
  >
    <span class="absolute left-1 top-1 px-1 py-0.5 rounded-sm
                 border border-surface/70 bg-on-surface/50 text-surface text-[11px] leading-tight">
      {{ swatch.label }}
    </span>
  </button>
</ng-template>

<ng-template #missingColorPlaceholder let-label>
  <div class="w-40 h-20 bg-surface1 flex items-center justify-center">
    <span class="text-label-small text-on-surface-variant">
      ({{ label }} color not found)
    </span>
  </div>
</ng-template>
